import React from 'react';
import PropTypes from 'prop-types';
import ButtonDeprecated, { BUTTON_THEME_BLUE_ADOBE_SMALL } from 'client/components/ButtonDeprecated';

import './SrDownloadButton.less';

/**
 * A compact button component for downloading files
 * @param {Object} props - Component props
 * @param {string} props.fileUrl - URL of the file to download
 * @param {string} [props.label] - Button text label
 * @param {string} [props.fontSize] - Optional font size override
 * @returns {React.Component} - Download button component
 */
const SrDownloadButton = ({ fileUrl, label, className, fontSize }) => {
  const style = fontSize ? { fontSize } : {};
  return (
    <ButtonDeprecated
      theme={BUTTON_THEME_BLUE_ADOBE_SMALL}
      href={fileUrl}
      download
      className={`compact-download-button ${className || ''}`}
      style={style}
      height="auto"
      width="auto"
    >
      {label || 'Download file'}
    </ButtonDeprecated>
  );
};

SrDownloadButton.propTypes = {
  fileUrl: PropTypes.string.isRequired,
  label: PropTypes.string,
  className: PropTypes.string,
  fontSize: PropTypes.string,
};

SrDownloadButton.defaultProps = {
  label: 'Download file',
};

export default SrDownloadButton;
